import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

// Shown immediately after a successful allocation, BEFORE the patient list is
// refetched, so the user can print a sticker or send the vacated bed to
// housekeeping without the card disappearing from under them.
export default function AllocationSuccessModal({
  open,
  result,
  onPrintSticker,
  onMarkCleaning,
  onRetainBed,
  onDone,
}) {
  const fromBed = result?.from_bed_code;
  const toBed = result?.to_bed_code;
  // Only offer cleaning when a different bed was actually vacated.
  const showClean = Boolean(fromBed && fromBed !== toBed);

  return (
    <Dialog open={open} onClose={onDone} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Bed Allocated</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "14px" }}>
          Bed <strong>{toBed || "—"}</strong> allocated successfully.
          {showClean && (
            <>
              {" "}
              Bed <strong>{fromBed}</strong> is now free.
            </>
          )}
        </Typography>
        {result?.accrual && (
          <Alert
            severity={result.accrual.severity}
            sx={{ mt: 1.5, fontSize: "13px" }}
          >
            {result.accrual.text}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <Button onClick={onPrintSticker}>Print Sticker</Button>
        {showClean && (
          <Button color="warning" onClick={onMarkCleaning}>
            Mark {fromBed} Cleaning
          </Button>
        )}
        {showClean && (
          <Button color="info" onClick={onRetainBed}>
            Retain {fromBed}
          </Button>
        )}
        <Button variant="contained" onClick={onDone}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
